module.exports = __webpack_public_path__ + "src/assets/games/19/421.jpg";